// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_NLMO7","content":"index_content_3_6lr","flag":"index_flag_VqTNz"};